



















































































































































import { Component, Vue } from "vue-property-decorator";
import { Currency } from "@/interfaces";
import { readHasAdminAccess } from "@/store/main/getters";
import { readUserOneWallet, readCurrencies } from "@/store/wallet/getters";
import { readAdminOneUser } from "@/store/admin/getters";
import {
  dispatchGetWallets,
  dispatchGetCurrencies,
  dispatchGetWalletsWithBalance
} from "@/store/wallet/actions";
import { dispatchGetUsers } from "@/store/admin/actions";

@Component
export default class RevertWithdraw extends Vue {
  public valid = true;
  public loading = true;
  public admin = false;


  public async mounted() {
    this.loading = true;
    const promises = [
      dispatchGetUsers(this.$store),
      dispatchGetCurrencies(this.$store)
    ];
    if (readHasAdminAccess(this.$store)) {
      promises.push(dispatchGetWalletsWithBalance(this.$store));
    } else {
      promises.push(dispatchGetWallets(this.$store));
    }
    await Promise.allSettled(promises);
    this.loading = false;

    if (readHasAdminAccess(this.$store)) this.admin = true;
  }

  public cancel() {
    this.$router.back();
  }
  public edit() {
    this.$router.push({
      name: "main-wallets-edit",
      params: { id: this.$router.currentRoute.params.id }
    });
  }

  public getCurrencyName(currencyId = this.wallet?.currency) {
    return readCurrencies(this.$store).find(
      (currency: Currency) => currency.id === currencyId
    )!.name;
  }

  public showBalance(balance: number, currency_id: number) {
    if (balance && this.getCurrencyName(currency_id) === "ETH")
      return `${(balance / 10 ** 18).toFixed(5)}`;
    if (balance && this.getCurrencyName(currency_id) === "ETC")
      return `${(balance / 10 ** 18).toFixed(5)}`;
    if (balance && this.getCurrencyName(currency_id) === "ZIL")
      return `${(balance / 10 ** 12).toFixed(5)}`;
    if (balance && this.getCurrencyName(currency_id) === "XCH")
      return `${(balance / 10 ** 12).toFixed(5)}`;
    if (balance && this.getCurrencyName(currency_id) === "XCC")
      return `${(balance / 10 ** 8).toFixed(5)}`;
    if (balance && this.getCurrencyName(currency_id) === "IRT")
      return balance.toLocaleString();
    return "0";
  }

  public getWalletBalance() {
    if (
      this.wallet?.wallet_balance &&
      this.getCurrencyName(this.wallet?.wallet_balance?.currency) === "ETH"
    )
      return this.wallet?.wallet_balance?.balance.toFixed(5);
    // if (
    //   this.wallet?.wallet_balance &&
    //   this.getCurrencyName(this.wallet?.wallet_balance?.currency) === "IRT"
    // )
    //   return "-";
    return "-";
  }

  get wallet() {
    return readUserOneWallet(this.$store)(+this.$router.currentRoute.params.id);
  }
  get user() {
    if (this.wallet?.owner_id)
      return readAdminOneUser(this.$store)(this.wallet?.owner_id);
    return null;
  }
}
